<template>
    <div class="border-top">
        <SOFilterTitle :title="title" :diterapkan="diterapkan" :id="id" />
        <div class="p-l-24 p-r-24 p-d-24" :id="id" :class="{ visible: !diterapkan }">
            <SOFilterSelectSkeleton v-if="pageSetting.loading" />
            <SOInputSelect
                ref="filterOneOutletSelect"
                v-if="!pageSetting.loading"
                :title="label"
                :selected="filterItem.oneOutlet"
                :placeholder="'Pilih nama outlet'"
                :options="options"
                @option-selected="selected"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOFilterSelectSkeleton from "@/so-components/global/filter/skeleton/SOFilterSelectSkeleton";
import SOInputSelect from "@/so-components/global/input/SOInputSelectV1";

export default {
    name: "SOFilterOneOutlet",
    components: {
        SOFilterTitle,
        SOFilterSelectSkeleton,
        SOInputSelect,
    },
    props: {
        id: String,
        title: {
            type: String,
            default: "Transaksi di Outlet",
        },
        label: {
            type: String,
            default: "Nama Outlet",
        },
        setDefault: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        ...mapGetters("outletModule", {
            outlets: "getOutlet",
        }),
        selectedOutlet() {
            return this.filterItem.oneOutlet;
        },
    },
    data() {
        return {
            pageSetting: {
                loading: true,
            },
            options: [],
            diterapkan: false,
        };
    },
    watch: {
        selectedOutlet: function (nSel, oSel) {
            if (nSel !== oSel) {
                this.$refs.filterOneOutletSelect.selectedOptions = nSel;
                this.diterapkan = this.filterItem.oneOutlet !== "";
            }
        },
    },
    mounted() {
        this.diterapkan = this.filterItem.oneOutlet !== "";
        this.getOutletAll();
    },
    methods: {
        async getOutletAll() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("outletModule/fetchOutletAll");
            if (res.success) {
                this.options = [];
                this.outlets.data.forEach((v) => {
                    this.options = [
                        ...this.options,
                        {
                            id: v.idoutlet,
                            text: v.nama,
                        },
                    ];
                });
            } else {
                this.$toast.error(res.err);
            }

            if (
                this.setDefault === true &&
                this.outlets &&
                this.outlets.data.length > 0 &&
                this.filterItem.oneOutlet === ""
            ) {
                this.selected(this.outlets.data[0].idoutlet);
            }
            this.pageSetting.loading = false;
        },
        selected(val) {
            let temp = this.filterItem;
            temp.oneOutlet = val;
            this.$store.commit("filterGlobalModule/setFilterItem", temp);
            this.diterapkan = this.filterItem.oneOutlet !== "";
        },
    },
};
</script>

<style scoped>
.visible {
    display: none;
}
</style>
